import React from 'react'
import {graphql} from 'gatsby'
import Img from 'gatsby-image'

import BasicPageHeading from '../components/basic-page-heading'
import Layout from '../components/layouts/layout'
import classes from './press.module.scss'
import {combine} from '../styles/classname-utils'
import PressResources from '../components/press-resources'
import FeaturedInSection from '../components/press/featured-in-section'

export default ({data}) => {
  const getData = (queryResult): {title: string, img: any, html: string} => {
    const {node} = queryResult.edges[0]
    const {title, img} = node.frontmatter
    const {html} = node
    return {title, img, html}
  }

  const arForEveryone = getData(data.arForEveryone)
  const theTech = getData(data.theTech)
  const meetTheFounder = getData(data.meetTheFounder)

  return (
    <Layout title='Press'>
      <BasicPageHeading>
        Press
      </BasicPageHeading>
      <section className='light'>
        <h2 className='text-center'>
          {arForEveryone.title}
        </h2>
        { /* eslint-disable react/no-danger */ }
        <div
          className={combine(classes.arForEveryone, classes.maxTabletWidth, 'text8-md max-width mx-auto')}
          dangerouslySetInnerHTML={{__html: arForEveryone.html}}
        />
        <h2 className='text-center'>
          {theTech.title}
        </h2>
        { /* eslint-disable react/no-danger */ }
        <div
          className={combine(classes.lastParagraph, classes.maxTabletWidth, 'text8-md max-width mx-auto')}
          dangerouslySetInnerHTML={{__html: theTech.html}}
        />
      </section>
      <section className='gray'>
        <h2 className='text-center'>
          {meetTheFounder.title}
        </h2>
        <div className='row justify-content-center mx-auto max-width'>
          <div>
            <Img
              className={classes.headshot}
              fluid={meetTheFounder.img.childImageSharp.fluid}
              alt={meetTheFounder.title}
            />
          </div>
          <div
            className={combine(classes.lastParagraph, classes.maxTabletWidth, 'text8-md')}
            dangerouslySetInnerHTML={{__html: meetTheFounder.html}}
          />
        </div>
      </section>
      <FeaturedInSection />
      <PressResources />
    </Layout>
  )
}

export const query = graphql`
  {
    arForEveryone:
      allMarkdownRemark(
        filter: {fileAbsolutePath: {glob: "**/docs/press/ar-for-everyone.md"}},
      ) {
        edges {
          node {
            fileAbsolutePath
            frontmatter {
              title
            }
            html
          }
        }
      }

    theTech:
      allMarkdownRemark(
        filter: {fileAbsolutePath: {glob: "**/docs/press/the-tech.md"}},
      ) {
        edges {
          node {
            fileAbsolutePath
            frontmatter {
              title
            }
            html
          }
        }
      }

    meetTheFounder:
      allMarkdownRemark(
        filter: {fileAbsolutePath: {glob: "**/docs/press/meet-the-founder.md"}},
      ) {
        edges {
          node {
            fileAbsolutePath
            frontmatter {
              title
              img {
                childImageSharp {
                  fluid(maxWidth: 240, quality: 100, srcSetBreakpoints: [240, 180]) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
            html
          }
        }
      }
  }
`
